import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/login/loading';

export const Route = createFileRoute('/_public/login/')({
  pendingComponent: Loading,
});
